import Vue from 'vue'
import Vuex from 'vuex'

import firebaseConfig from "@/firebaseConfig";
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";


//import { getAuth, onAuthStateChanged } from "firebase/auth";

import user from './user'
import shared from './shared'
import payments from './payments'

const app = initializeApp(firebaseConfig);

const getters = {
  fbUiApp: state => state.fbUiApp
}

const state = {
  firebase: app,
  db: getFirestore(app),
  storage: getStorage(app)
  // auth: getAuth(),
  // onAuthStateChanged: onAuthStateChanged(getAuth())
}

Vue.use(Vuex)

export const store = new Vuex.Store({
  state,
  getters,
  modules: {
    user: user,
    shared: shared,
    payments: payments
  }
})
